import "../assets/css/material-dashboard.css";
import "../assets/css/material-dashboard.css.map";
import "../assets/css/nucleo-icons.css";
import "../assets/css/nucleo-svg.css";
import "../assets/css/material-dashboard.min.css";
import "./SideNav.css";
import requirementIcon from "../assets/img/small-logos/requeriments-svgrepo-com.svg";
import workersIcon from "../assets/img/small-logos/engineer-svgrepo-com.svg";
import usersIcon from "../assets/img/small-logos/users-svgrepo-com.svg"
import withdrawIcon from "../assets/img/small-logos/money-withdraw-svgrepo-com.svg";
import helpSupportIcon from "../assets/img/small-logos/drawer-support-svgrepo-com (1).svg";
import salesIcon from "../assets/img/small-logos/sales-amount-svgrepo-com.svg";
import transactionsIcon from "../assets/img/small-logos/of-hand-clasping-money-svgrepo-com.svg";
import doorstepOrderIcon from "../assets/img/icons/shopping-cart-svgrepo-com.svg";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import downIcon from "../assets/img/icons/down-arrow-svgrepo-com.svg"
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import crossIcon from "../assets/img/cross-svg.svg"
import { setMenu } from "src/store/hamburgerMenu";
import ratingStar from "../assets/img/icons/rating-star-svgrepo-com.svg";
import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';
// interface SideNavbarProps {
//     isOpen?: boolean;
// }

const SideNavbar = () => {
    const [clickedContent, setClickedContent] = useState({
        content: false,
        service: false,
        transactions: false
    });
    const menuToggle = useAppSelector(state => state?.toggleMenu?.value);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleContentClick = (type: string) => {
        if (type === "content") {
            setClickedContent(prevState => ({
                ...prevState,
                service: false,
                content: !prevState.content,

            }));
        }
        if (type === "service") {
            setClickedContent(prevState => ({
                ...prevState,
                content: false,
                service: !prevState.service
            }));
        }
        if (type === "transactions") {
            setClickedContent(prevState => ({
                ...prevState,
                content: false,
                service: false,
                transactions: !prevState.transactions
            }));
        }

    };


    let currentEndpoint = window.location.pathname;
    useEffect(() => {


        if (currentEndpoint.includes("/admin/worker/category")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/admin/worker/sub-categories")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }

        else if (currentEndpoint.includes("/admin/doorstep/categories")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/admin/doorstep/services")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/admin/professional/services")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/admin/subscriptions/plans")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/admin/membership/plans")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/feature-values")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }

        else if (currentEndpoint.includes("/admin/requeriment-values")) {
            setClickedContent(prevState => ({
                ...prevState,
                content: true
            }));
        }
        else if (currentEndpoint.includes("/admin/membership/sales")) {
            setClickedContent(prevState => ({
                ...prevState,
                service: true
            }))
        }
        else if (currentEndpoint.includes("/admin/membership/sales")) {
            setClickedContent(prevState => ({
                ...prevState,
                service: true
            }))
        }
        else if (currentEndpoint.includes("/admin/subscription/sales")) {
            setClickedContent(prevState => ({
                ...prevState,
                service: true
            }))
        }

    }, []);

    const handleLogOut = () => {
        const token: string | undefined = Cookies.get('token');
        const refreshToken: string | undefined = Cookies.get('refreshToken');

        if (token || refreshToken) {
            Cookies.remove('token');  // Properly removes the cookie
            Cookies.remove('refreshToken');

            console.log("Logged out, previous tokens:", token, refreshToken);

            toast.success("Logged out successfully.", {
                position: "top-right",
                duration: 1000
            });

            setTimeout(() => {
                navigate("/sign-in"); // Redirect after logout
            }, 1000);
        }
    };


    const openCloseMenu = () => {
        dispatch(setMenu(!menuToggle))
    }
    return (



        <nav className={`fixed-start sidenav navbar navbar-vertical navbar-expand-xs`} >
            <Toaster />
            <div className="g-sidenav-show  bg-gray-200 ">
                <aside
                    className={`sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 
                    fixed-start ms-3 bg-gradient-dark ${menuToggle ? "open-menu" : ""}`} id="sidenav-main" >
                    <div className="sidenav-header">
                        <i className="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
                        <a className="navbar-brand m-0" target="_blank">
                            {/* <img src="../assets/img/logo-ct.png" className="navbar-brand-img h-100" alt="main_logo" />/// */}
                            <span className="ms-1 font-weight-bold text-white">Yows Admin Dashboard</span>

                        </a>
                        <span className=" hide-icon" onClick={openCloseMenu}>
                            <img src={crossIcon} alt="hide-btn" />
                        </span>
                    </div>
                    <hr className="horizontal light mt-0 mb-2" />
                    <div className="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/home") ? 'active' : ''} nav-link text-white `} to="/home">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        <i className="material-icons opacity-10">dashboard</i>
                                    </div>
                                    <span className="nav-link-text ms-1">Dashboard</span>
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/users") ? 'active' : ''} nav-link text-white`} to="/users">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={usersIcon} alt="users-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1">Users</span>
                                </Link>

                            </li>
                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/workers") ? 'active' : ''} nav-link text-white`} to="/workers">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={workersIcon} alt="worker-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1">Workers</span>
                                </Link>

                            </li>

                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/doorstep-orders") ? 'active' : ''} nav-link text-white`} to="/doorstep-orders">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={doorstepOrderIcon} alt="doorstep-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1">Doorstep Orders</span>
                                </Link>

                            </li>
                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/requirements") ? 'active' : ''} nav-link text-white`} to="/requirements">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        <img src={requirementIcon} alt="requirement-icon" style={{ width: "20px", height: "20px" }} />
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                    </div>
                                    <span className="nav-link-text ms-1"> Requirements</span>
                                </Link>

                            </li>

                            <li className="nav-item" onClick={() => handleContentClick("content")}>
                                <div className="nav-link text-white gap-2">
                                    <div className="d-flex">
                                        <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                            <i className="material-icons opacity-10">table_view</i>
                                            {/* <img src={contentIcon} alt="users-icon" style={{ width: "20px", height: "20px" }} /> */}
                                        </div>

                                        <span className="nav-link-text ms-1">Content Management</span>
                                    </div>

                                    <span className="d-flex justify-content-center align-items-center">
                                        <img src={downIcon} alt="down-icon" style={{ width: "15px", height: "15px" }} />
                                    </span>
                                </div>


                            </li>
                            {
                                clickedContent.content &&
                                <li>
                                    <div className="d-flex flex-column text-white justify-content-center" style={{ listStyle: "initial", margin: "0 1rem", gap: "7px", cursor: "pointer", }}>
                                        <Link onClick={openCloseMenu} to="/worker/category"
                                            className={`text-white nav-link ps-2 d-flex gap-3 sub-icons ${currentEndpoint.includes('/worker/category') ? 'active' : ''}`}>
                                            <span>&#x25cf;</span> <span className="text-start text-white " >
                                                Categories
                                            </span>
                                        </Link>

                                            <Link onClick={openCloseMenu} to="/worker/sub-categories"
                                                className={`text-white nav-link ps-2 d-flex gap-3 sub-icons ${currentEndpoint.includes('/worker/sub-category') ? 'active' : ''}`}>
                                                <span>&#x25cf;</span> <span className="text-start text-white " >
                                                    Sub Categories
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/doorstep/categories"
                                                className={`text-white nav-link ps-2 d-flex gap-3 sub-icons ${currentEndpoint.includes('/doorstep/categories') ? 'active' : ''}`}>
                                                <span>&#x25cf;</span><span className="text-start text-white " >
                                                    Doorstep Categories
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/doorstep/services"
                                                className={`text-white nav-link ps-2 d-flex gap-3 sub-icons ${currentEndpoint.includes('/doorstep/services') ? 'active' : ''}`}>
                                                <span>&#x25cf;</span><span className="text-start text-white " >
                                                    Doorstep Services
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/professional/services"
                                                className={`text-white nav-link ps-2 d-flex gap-3 sub-icons ${currentEndpoint.includes('/professional/services') ? 'active' : ''}`}>
                                                <span>&#x25cf;</span><span className="text-start text-white " >
                                                    Professional Services
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/requeriment-values"
                                                className={`text-white nav-link ps-2 d-flex gap-3 sub-icons ${currentEndpoint.includes('/requeriment-values') ? 'active' : ''}`}>
                                                <span>&#x25cf;</span><span className="text-start text-white " >
                                                    Requirement Values
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/subscriptions/plans" className="text-white nav-link ps-2 d-flex gap-3 sub-icons">
                                                <span>&#x25cf;</span> <span className="text-start text-white " >
                                                    Subscriptions
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/membership/plans" className="text-white nav-link ps-2 d-flex gap-3 sub-icons">
                                                <span>&#x25cf;</span> <span className="text-start text-white " >
                                                    Membership
                                                </span>
                                            </Link>

                                            <Link onClick={openCloseMenu} to="/feature-values" className="text-white nav-link ps-2 d-flex gap-3 sub-icons">
                                                <span>&#x25cf;</span> <span className="text-start text-white " >
                                                    Feature Values
                                                </span>
                                            </Link>

                                        </div>

                                </li>
                            }

                            <li className="nav-item" onClick={() => handleContentClick("service")}>
                                <div className="nav-link text-white  gap-2">
                                    <div className="d-flex">
                                        <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                            {/* <i className="material-icons opacity-10">table_view</i> */}
                                            <img src={salesIcon} alt="down-icon" style={{ width: "20px", height: "20px" }} />
                                        </div>

                                        <span className="nav-link-text ms-1">Sales</span>
                                    </div>

                                    <span className="d-flex justify-content-center align-items-center">
                                        <img src={downIcon} alt="down-icon" style={{ width: "15px", height: "15px" }} />
                                    </span>

                                </div>
                            </li>

                            {
                                clickedContent.service &&
                                <li>
                                    <div className="d-flex flex-column text-white justify-content-center" style={{ listStyle: "initial", margin: "0 1rem", gap: "7px", cursor: "pointer", }}>
                                        <Link onClick={openCloseMenu} to="/membership/sales" className="text-white nav-link ps-2 d-flex gap-3 sub-icons">
                                            <span>&#x25cf;</span> <span className="text-start text-white " >
                                                Membership Sales
                                            </span>
                                        </Link>
                                        <Link onClick={openCloseMenu} to="/subscription/sales" className="text-white nav-link ps-2 d-flex gap-3 sub-icons">
                                            <span>&#x25cf;</span> <span className="text-start text-white " >
                                                Subscription Sales
                                            </span>
                                        </Link>
                                    </div>
                                </li>
                            }
                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/reviews") ? 'active' : ''} nav-link text-white`} to="/reviews">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={ratingStar} alt="rating-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1"> Reviews</span>
                                </Link>

                            </li>

                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/transactions") ? 'active' : ''} nav-link text-white`} to="/transactions">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={transactionsIcon} alt="Withdraw-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1"> Transactions</span>
                                </Link>

                            </li>


                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/withdraw-requests") ? 'active' : ''} nav-link text-white`} to="/withdraw-requests">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={withdrawIcon} alt="Withdraw-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1">Withdraw Request</span>
                                </Link>

                            </li>
                            <li className="nav-item">
                                <Link onClick={openCloseMenu} className={`${currentEndpoint.includes("/support") ? 'active' : ''} nav-link text-white`} to="/support">
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        {/* <i className="material-icons opacity-10">receipt_long</i> */}
                                        <img src={helpSupportIcon} alt="hel-support-icon" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                    <span className="nav-link-text ms-1">Help & Support</span>
                                </Link>

                            </li>


                            <li className="nav-item">
                                <a className={`nav-link text-white`} onClick={handleLogOut}>
                                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                        <i className="material-icons opacity-10">login</i>
                                    </div>
                                    <span className="nav-link-text ms-1">Log Out</span>
                                </a>
                            </li>

                        </ul>
                    </div>

                </aside>

                {/* Core JS Files   */}
                <script src="../assets/js/core/popper.min.js" />
                <script src="../assets/js/core/bootstrap.min.js" />
                <script src="../assets/js/plugins/perfect-scrollbar.min.js" />
                <script src="../assets/js/plugins/smooth-scrollbar.min.js" />
                <script src="../assets/js/plugins/chartjs.min.js" />
                <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900|Roboto+Slab:400,700" />
                {/* <!-- Nucleo Icons --> */}
                <link href="../assets/css/nucleo-icons.css" rel="stylesheet" />
                <link href="../assets/css/nucleo-svg.css" rel="stylesheet" />
                {/* <!-- Font Awesome Icons --> */}
                <script src="https://kit.fontawesome.com/42d5adcbca.js" />
                {/* <!-- Material Icons --> */}
                <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Round" rel="stylesheet" />
                {/* <!-- CSS Files --> */}
                <link id="pagestyle" href="../assets/css/material-dashboard.css?v=3.1.0" rel="stylesheet" />

            </div>
        </nav> 



    );
};



export default SideNavbar;